import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

export default {
  metaText: css`
    max-width: 125px;
  `,
  placeCheckboxText: (isExpanded) => css`
    color: ${isExpanded ? colors.blue60 : ''};
    margin-inline-start: -6px;
  `,
  singleIndent: css`
    padding-inline-start: 36px;
  `,
  colorButton: css`
    & button {
      color: ${colors.blue60};
    }

    & button:hover {
      background-color: ${colors.blue03} !important;
    }
  `,
  adjustIcon: css`
    span {
      position: relative;
      top: 4px;
    }
  `,
}
